export default __webpack_public_path__ + "static/media/Suwit-jawa.90fdac5b.png";